export const Card = ({ title, children, className, bodyClassName, ...props }) => {
    return <div className={`bg-grey shadow-lg rounded-lg p-6 ${className}`} {...props}>
        <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
        <div className={`mt-4 ${bodyClassName}`}>
            {children}
        </div>
    </div>
}